import React from 'react';
import logoAbout from '../assets/logo-about.png';


const AboutUs = () => {
  return (
    <div className="container mt-5 mb-5 text-center">
      <img
        src={logoAbout}
        alt="IoVendoSiciliano Logo"
        style={{ width: '180px', marginBottom: '30px' }}
      />

      <h2 className="text-success fw-bold mb-4">About Us</h2>
      <p style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
        L'Associazione ha come scopo di promuovere il benessere della comunità,
        sensibilizzare su tematiche sociali, culturali, ambientali e di
        valorizzazione del patrimonio culturale e agroalimentare siciliano, nonché
        di offrire supporto alle persone in difficoltà.
      </p>
    </div>
  );
};

export default AboutUs;
